import dictionary from './locale-zh.json' with {type:'json'};
import extra from './locale-zh-extra.json' with {type:'json'};
const copy:Record<string,string>={...dictionary,...extra};
const folded=Object.fromEntries(Object.entries(copy).map(([key,value])=>[key.toLowerCase(),value]));
const escapeRegex=(s:string)=>s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
const keys=Object.keys(copy).sort((a,b)=>b.length-a.length);
const fragments=keys.length?new RegExp(keys.map(k=>`${/^[A-Za-z0-9_]/.test(k)?'(?<![A-Za-z0-9_-])':''}${escapeRegex(k)}${/[A-Za-z0-9_]$/.test(k)?'(?![A-Za-z0-9_-])':''}`).join('|'),'gi'):null;
/** Display-only translation. Values, identifiers, addresses and signed payloads are never passed through this function. */
export function zh(value:unknown):string {
  const text=String(value??''),key=text.replace(/\s+/g,' ').trim();
  if(!/[A-Za-z]/.test(text)||/^0x[0-9a-f]+$/i.test(key)||/^(?:https?:\/\/|ipfs:\/\/)\S+$/i.test(key))return text;
  const translated=copy[key]??folded[key.toLowerCase()];
  if(translated!==undefined)return text.slice(0,text.indexOf(text.trimStart()))+translated+(text.match(/\s*$/)?.[0]||'');
  if(!fragments)return text;
  // A scanner URL is itself a capability. It must remain byte-for-byte copyable,
  // including paths whose words also occur in the UI dictionary.
  return text.split(/((?:https?:\/\/|ipfs:\/\/)[^\s<>"']+)/gi).map(part=>/^(?:https?:\/\/|ipfs:\/\/)/i.test(part)?part:part.replace(fragments,s=>copy[s]??folded[s.toLowerCase()])).join('');
}
const decode=(s:string)=>s.replace(/&nbsp;/g,' ').replace(/&amp;/g,'&').replace(/&#39;|&apos;/g,"'").replace(/&quot;/g,'"').replace(/&lt;/g,'<').replace(/&gt;/g,'>');
const encode=(s:string)=>s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
/** Translate only text and human-readable attributes, preserving DOM IDs, form values and markup. */
export function zhHtml(value:unknown):string {
  const html=String(value??'');let preserveTag:string|null=null;
  return html.split(/(<!--[\s\S]*?-->|<(?:"[^"]*"|'[^']*'|[^'">])*?>)/g).map(part=>{
    if(part.startsWith('<')){
      if(preserveTag){if(new RegExp(`^<\\/${preserveTag}\\b`,'i').test(part))preserveTag=null;return part;}
      const raw=/^<(script|style|pre|code|textarea)\b/i.exec(part);
      if(raw){preserveTag=raw[1];return part;}
      if(part.startsWith('<!--'))return part;
      return part.replace(/\b(title|placeholder|aria-label|alt)\s*=\s*(["'])(.*?)\2/g,(_m,key,quote,text)=>`${key}=${quote}${encode(zh(decode(text))).replace(/"/g,'&quot;').replace(/'/g,'&#39;')}${quote}`);
    }
    if(preserveTag)return part;
    const original=decode(part),translated=zh(original);return original===translated?part:encode(translated);
  }).join('');
}
